import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import { connect } from "react-redux";
import { TAB } from "../constants";
import { actionCreators, getActiveDocumentId, getActiveDocumentType } from "../redux";
import Navigation from "./navigation";
const mapStateToProps = (state) => ({
    documentType: getActiveDocumentType(state),
    activeDocumentId: getActiveDocumentId(state)
});
const mapDispatchToProps = (dispatch) => ({
    onDocumentTypeChanged: documentType => {
        if (documentType === DOCUMENT_TYPE.CONTENT)
            dispatch(actionCreators.setTab(TAB.NAVIGATION));
    },
    onChangeDocumentType: (documentId, selectedType) => dispatch(actionCreators.setDocumentType(documentId, selectedType))
});
export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
